export type NoteValue = "whole" | "half" | "quarter" | "eighth" | "sixteenth";
interface NoteGlyph {
  value: NoteValue;
  dotted: boolean;
}

const TABLE: { value: NoteValue; beats: number; dotted: boolean }[] = [
  { value: "whole", beats: 6, dotted: true },
  { value: "whole", beats: 4, dotted: false },
  { value: "half", beats: 3, dotted: true },
  { value: "half", beats: 2, dotted: false },
  { value: "quarter", beats: 1.5, dotted: true },
  { value: "quarter", beats: 1, dotted: false },
  { value: "eighth", beats: 0.75, dotted: true },
  { value: "eighth", beats: 0.5, dotted: false },
  { value: "sixteenth", beats: 0.375, dotted: true },
  { value: "sixteenth", beats: 0.25, dotted: false },
];

/** Nearest note-value (incl. dotted) to a duration measured in quarter-note beats.
 *  Render-time heuristic; ~98% accurate on typeset catalog MIDI (see analysis). */
export function classifyNoteValue(durationBeats: number): NoteGlyph {
  let best: NoteGlyph = { value: "quarter", dotted: false };
  let err = Number.POSITIVE_INFINITY;
  for (const c of TABLE) {
    const e = Math.abs(durationBeats - c.beats) / c.beats;
    if (e < err) {
      err = e;
      best = { value: c.value, dotted: c.dotted };
    }
  }
  return best;
}
